import axios from "axios";

export default axios.create({
	baseURL: import.meta.env.VITE_BASE_URL
});

export const axiosPrivate = axios.create({
	baseURL: import.meta.env.VITE_BASE_URL,
	headers: { "Content-Type": "application/json" }
	// withCredentials: true
});

// Matrix chat axios instance
export const matrixAxios = axios.create({
	baseURL: "/_matrix/client/v3",
	headers: {
		"Content-Type": "application/json"
	}
});

// Add request interceptor to add Matrix auth token
matrixAxios.interceptors.request.use((config) => {
	const token = config.headers?.Authorization;
	if (token && typeof token === "string" && !token.startsWith("Bearer ")) {
		config.headers.Authorization = `Bearer ${token}`;
	}
	return config;
});

// Add response interceptor to handle Matrix errors
matrixAxios.interceptors.response.use(
	response => response,
	(error) => {
		if (error.response) {
			throw new Error(`Matrix API error: ${error.response.data?.error || error.response.statusText}`);
		}
		throw error;
	}
);
